export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

export const isEmpty = (value) => {
  return value.trim() === "";
};

export const containsScript = (value) => {
  const scriptRegex = /<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi;
  return scriptRegex.test(value);
};

export const sanitizeInput = (input) => {
  const element = document.createElement('div');
  element.innerText = input;
  return element.innerHTML;
};

export const validateEmail = (email) => {
  if (!email || isEmpty(email)) {
    return "Email field cannot be empty";
  }
  if (containsScript(email)) {
    return "Email cannot contain script tags";
  }
  if (!isValidEmail(email)) {
    return "Please enter a valid email address (must contain '@' and a domain like '.com')";
  }
  return "";
};

export const validatePassword = (password) => {
  if (!password || isEmpty(password)) {
    return "Password field cannot be empty";
  }
  if (containsScript(password)) {
    return "Password cannot contain script tags";
  }
  if (password.length < 8) {
    return "Password must be at least 6 characters";
  }
  return "";
};
